export default {
  platformNotifications: {},
}
